import instance from 'utils/apiCalls';
import { paramsI } from '../../../types/interface';
import { applicationSlice } from './applicationSlice';
import { APPLICATION_URLS } from './applicationUrls';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'redux/store';
import { Action } from '@reduxjs/toolkit';

const { actions } = applicationSlice;
export const getAllApplication =
  (params: paramsI) =>
  async (
    dispatch: ThunkDispatch<RootState[keyof RootState], unknown, Action>
  ) => {
    const response = await instance.get(APPLICATION_URLS.GET_ALL_APPLICATION, {
      params: params
    });
    if (Number(response?.data?.meta?.currentPage) === 1) {
      dispatch(
        actions.setApplicationTotalPages({
          totalPages: response?.data?.meta?.totalPages,
          totalRecords: response?.data?.meta?.totalRecords
        })
      );
    }
    return response;
  };

export const getSingleApplicationHealth = (id: number) => async () => {
  const response = await instance.get(
    `${APPLICATION_URLS.GET_SINGLE_APPLICATION_HEALTH}/${id}`
  );
  return response;
};

export const getSingleApplicationEducation = (id: number) => async () => {
  const response = await instance.get(
    `${APPLICATION_URLS.GET_SINGLE_APPLICATION_EDUCATION}/${id}`
  );
  return response;
};

export const getAllApplicationTypeRequest = () => async () => {
  const response = await instance.get(APPLICATION_URLS.GET_ALL_REQUEST);
  return response;
};

export const changeStatusOfApplication =
  (id: string, status: 'APPROVED' | 'REJECTED' | 'PENDING', review: string) =>
  async () => {
    const response = await instance.put(
      APPLICATION_URLS.CHANGE_APPLICATION_STATUS.replace(':application_id', id),
      {
        application_status: status,
        reason: review
      }
    );
    return response;
  };

export const getRequestOptionById = (id: number) => async () => {
  const response = await instance.get(
    `${APPLICATION_URLS.GET_ALL_OPTION}/${id}`
  );
  return response;
};
